import React from "react";
import { observer } from "mobx-react";
import { TenantProfileViewStore } from "../../store";
import { TenantProfileViewForm } from "./TenantProfileViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type TenantProfileViewProps = {
  tenantProfileViewStore: TenantProfileViewStore;
};

export const TenantProfileView: React.FC<TenantProfileViewProps> = observer(
  ({ tenantProfileViewStore }) => {
    return (
      <div>
        <TenantProfileViewForm
          tenantProfileViewStore={tenantProfileViewStore}
          personTypeOptions={tenantProfileViewStore.getPersonTypeOptions()}
          personType={tenantProfileViewStore.personTypeValue}
          legalName={tenantProfileViewStore.legalNameValue}
          ownPublisherValue={tenantProfileViewStore.ownPublisherValue}
          businessId={tenantProfileViewStore.businessIdValue}
          legalEmail={tenantProfileViewStore.legalEmailValue}
          streetAndNumber={tenantProfileViewStore.streetAndNumberValue}
          floor={tenantProfileViewStore.floorValue}
          suite={tenantProfileViewStore.suiteValue}
          postalCode={tenantProfileViewStore.postalCodeValue}
          countryValue={tenantProfileViewStore.countryValue}
          provinceValue={tenantProfileViewStore.provinceValue}
          city={tenantProfileViewStore.cityValue}
          vatStatusValue={tenantProfileViewStore.vatStatusValue}
          taxId={tenantProfileViewStore.taxIdValue}
          grossReceiptsStatusValue={
            tenantProfileViewStore.grossReceiptsStatusValue
          }
          grossReceiptsId={tenantProfileViewStore.grossReceiptsIdValue}
          billingEmail={tenantProfileViewStore.billingEmailValue}
          billingCurrencyValue={tenantProfileViewStore.billingCurrencyValue}
          printerName={tenantProfileViewStore.printerNameValue}
          printerStreetAndNumber={
            tenantProfileViewStore.printerStreetAndNumberValue
          }
          printerFloor={tenantProfileViewStore.printerFloorValue}
          printerSuite={tenantProfileViewStore.printerSuiteValue}
          printerPostalCode={tenantProfileViewStore.printerPostalCodeValue}
          printerCountryValue={tenantProfileViewStore.printerCountryValue}
          printerProvinceValue={tenantProfileViewStore.printerProvinceValue}
          printerCity={tenantProfileViewStore.printerCityValue}
          sadaicFtpUrl={tenantProfileViewStore.sadaicFtpUrlValue}
          sadaicFtpUser={tenantProfileViewStore.sadaicFtpUserValue}
          sadaicEmail={tenantProfileViewStore.sadaicEmailValue}
          onPrint={(handlePrint: () => void) =>
            tenantProfileViewStore.printTenantProfile(handlePrint)
          }
          onCancel={() => tenantProfileViewStore.cancelTenantProfile()}
          onEdit={
            tenantProfileViewStore.isEditEnabled
              ? () => tenantProfileViewStore.editTenantProfile()
              : undefined
          }
        />
        <ErrorDialog
          open={tenantProfileViewStore.errorDialogOpened}
          title={tenantProfileViewStore.errorTitle}
          description={tenantProfileViewStore.errorDescription}
          onClose={() => tenantProfileViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
